import { useContext, useState } from "react";
import {
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Paper,
	TableContainer,
	TableFooter,
	LinearProgress,
} from "@mui/material";
import { ArrowRight, ArrowLeft } from "@mui/icons-material";
import Stack from "@mui/material/Stack";
import EditIcon from "@mui/icons-material/Edit";
import { ContextRegisterClient } from "../context";
import "./style.css";
import ModalMain from "../../../modal";
import FormManagerConfig from "../../../../pages/register/account-entry/Manager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { ContextGlobal } from "../../../../context";

const itemsPerPage = 15; // Quantidade de itens por página

function TableClients({ isSelector, onSelectClient, ...props }) {
	const { clientsData, openModalRegisterClient, fetchClientsPage, currentPage, setPage, page, totalPage, loading } =
		useContext(ContextRegisterClient);

	const { enterpriseData } = useContext(ContextGlobal);

	const [selectData, setSelectData] = useState({});

	const handleChangePage = (event, newPage) => {
		//se a pagina não foi carregada faz a pesquisa no banco
		if (newPage > currentPage.current) {
			fetchClientsPage();
		}

		if (totalPage > 0) {
			if (newPage > totalPage) return;
		}

		setPage(newPage);
	};

	// Customização do componente de paginação
	function CustomPagination({ count, page, onChangePage, totalRecord }) {
		return (
			<Stack direction="row" spacing={2} alignItems={"center"} justifyContent="center" mt={2}>
				<button className="pagination-btn" disabled={page === 1} onClick={() => onChangePage(null, page - 1)}>
					<ArrowLeft />
				</button>
				<div className="pagination-page d-flex align-items-center">
					<span className="page">{page}</span>
					{totalRecord > itemsPerPage && <span className="page-more"> ... </span>}
				</div>

				{/* <button className="pagination-btn" onClick={() => onChangePage(null, page + 1)}> */}
				<button
					className="pagination-btn"
					disabled={clientsData?.length === 0 || (totalPage > 0 && page + 1 > totalPage)}
					onClick={() => onChangePage(null, page + 1)}
				>
					<ArrowRight />
				</button>
			</Stack>
		);
	}

	const startIndex = (page - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const slicedData = clientsData.slice(startIndex, endIndex);

	const handleConfig = (item) => {
		setSelectData(item);
		handleOpenModalAux(item);
	};

	const handleOpenModalAux = () => {
		const event = new CustomEvent(`${"aux"}`);
		window.dispatchEvent(event);
	};

	// const theme = useTheme();
	// const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<>
			{/* <Paper> */}
			<TableContainer component={Paper}>
				<Table>
					<TableHead className="color-table">
						<TableRow>
							<TableCell
								style={{
									width: "250px",
									whiteSpace: "nowrap",
								}}
							>
								<span className="text-color-table">Nome</span>
							</TableCell>
							<>
								<TableCell style={{ width: "150px" }}>
									<span className="text-color-table">Endereço</span>
								</TableCell>
								<TableCell style={{ width: "150px" }}>
									<span className="text-color-table">Bairro</span>
								</TableCell>
							</>
							<TableCell style={{ width: "100px", textAlign: "center" }}>
								<span className="text-color-table">Telefone</span>
							</TableCell>
							<TableCell style={{ width: "100px", textAlign: "center" }}>
								<span className="text-color-table">Telefone</span>
							</TableCell>
							<>
								<TableCell
									style={{
										textAlign: "center",
										verticalAlign: "middle",
									}}
								>
									<span className="text-color-table">Ativo</span>
								</TableCell>
							</>

							<TableCell 
								style={{ 
									position: "sticky", 
									right: 0, 
									backgroundColor: "var(--texto-secondary)", 
									zIndex: 10,
									textAlign: "center",
									width: "120px"
								}}
							>
								<span className="text-color-table">Ações</span>
							</TableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						{slicedData.map((item, key) => (
							<TableRow key={key} className="zebra-row">
								<TableCell style={{ whiteSpace: "nowrap" }}>{item.nome}</TableCell>

								<>
									<TableCell style={{ whiteSpace: "nowrap" }}>
										{item.rua}, {item.numero}
									</TableCell>
									<TableCell style={{ whiteSpace: "nowrap" }}>{item.bairro}</TableCell>
								</>

								<TableCell style={{ whiteSpace: "nowrap" }}>{item.telefone_1}</TableCell>
								<TableCell style={{ whiteSpace: "nowrap" }}>{item.telefone_2}</TableCell>

								<>
									<TableCell
										style={{
											textAlign: "center",
											verticalAlign: "middle",
										}}
									>
										{item.ativo}
									</TableCell>
								</>

								<TableCell
									style={{
										textAlign: "center",
										verticalAlign: "middle",
										position: "sticky",
										right: 0,
										backgroundColor: "#fff",
										zIndex: 2,
										boxShadow: "-2px 0 5px rgba(0,0,0,0.05)"
									}}
								>
									<div className="flex justify-center items-center gap-2">
										<button
											className="btn btn-sm btn-outline-primary"
											onClick={(e) => openModalRegisterClient(item)}
										>
											<EditIcon fontSize="small" />
										</button>
										{enterpriseData?.id_empresa === 1 && (
											<button
												className="btn btn-sm btn-outline-primary"
												onClick={(e) => handleConfig(item)}
											>
												<FontAwesomeIcon icon={faCog} />
											</button>
										)}
										{isSelector && (
											<button
												className="btn btn-sm btn-outline-success min-w-[90px]"
												onClick={() => onSelectClient && onSelectClient(item)}
											>
												Selecionar
											</button>
										)}
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
					{loading ? (
						<TableFooter>
							<TableRow>
								<TableCell colSpan={document.querySelectorAll("thead th").length}>
									<LinearProgress variant="indeterminate" />
								</TableCell>
							</TableRow>
						</TableFooter>
					) : (
						clientsData.length === 0 && (
							<TableBody>
								<TableRow>
									<TableCell
										colSpan={document.querySelectorAll("thead th").length}
										className="italic text-gray-400"
									>
										Nenhum registro encontrado.
									</TableCell>
								</TableRow>
							</TableBody>
						)
					)}
				</Table>
				{/* {loading && (
					<div className="flex h-44">
						<Loading mensagem={"Carregando dados dos clientes"} />
					</div>
				)} */}
				<CustomPagination
					count={Math.ceil(clientsData.length / itemsPerPage)}
					page={page}
					onChangePage={handleChangePage}
					totalRecord={clientsData.length}
				/>
				{/* </Paper> */}
			</TableContainer>
			{enterpriseData?.id_empresa === 1 && (
				<ModalMain ident={"aux"}>
					<>
						<FormManagerConfig selectedData={selectData} />
					</>
				</ModalMain>
			)}
		</>
	);
}

export default TableClients;

/* <Stack sx={{ justifyContent: "center", alignItems: "center", mt: 2 }}>
							<Pagination
								count={Math.ceil(clientsData.length / itemsPerPage)}
								page={page}
								onChange={handleChangePage}
							/>
						</Stack> */
